"use client";
import { apiSubscribeNewsletter } from "@/apis/page_optimization";
import { faPaperPlane, FontAwesomeIcon } from "@/constants/icons";
import React, { useState } from "react";
import { toast } from "react-toastify";

interface Props {
  companyId: string;
  domain: string;
}

const FooterNewsletter = ({ companyId, domain }: Props) => {
  const [email, setEmail] = useState<string>("");
  const [error, setError] = useState<string>("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const validateEmail = (email: string) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  const handleRate = async (e: React.FormEvent, p_email: string) => {
    e.preventDefault();

    if (!validateEmail(p_email)) {
      setError("Please enter a valid email address.");
      toast.error("Please enter a valid email address.");
      return;
    }
    setEmail(p_email);
    setError("");
    await handleSubmit();
  };

  const handleSubmit = async () => {
    setIsSubmitting(true);
    try {
      const response = await apiSubscribeNewsletter(companyId, email);
      if (response.message == "Subscribed successfully") {
        toast.success("Thank you for your feedback!", { autoClose: 2000 });
        setEmail("");
      } else {
        toast.error("You have already subscribed to our newsletter.");
      }
    } catch (error) {
      console.error("Error subscribing:", error);
      toast.error("There was an error subscribing. Please try again later.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="w-full max-w-full overflow-hidden">
      <form
        className="relative w-full"
        onSubmit={(e) => {
          handleRate(e, email);
        }}
        autoComplete="off"
      >
        {/* Input Container */}
        <div className="group relative flex items-center w-full bg-black/40 rounded-2xl p-1.5 border border-white/5 focus-within:border-orange-500/50 transition-all duration-500 shadow-2xl">
          <div className="absolute inset-0 rounded-2xl bg-orange-500/5 opacity-0 group-focus-within:opacity-100 transition-opacity pointer-events-none" />

          <input
            type="email"
            placeholder="access@deals.com"
            className="flex-1 bg-transparent border-none outline-none px-3 md:px-5 py-3 text-[13px] font-bold tracking-widest text-slate-100 placeholder-zinc-600 focus:ring-0 z-10 min-w-0"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            disabled={isSubmitting}
          />

          {/* Button Container */}
          <button
            type="submit"
            disabled={isSubmitting}
            className="relative z-10 flex justify-center items-center rounded-xl w-11 h-11 md:w-12 md:h-12 bg-orange-600 hover:bg-orange-500 text-white transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed group shadow-[0_0_20px_rgba(249,115,22,0.2)] hover:shadow-[0_0_30px_rgba(249,115,22,0.4)] active:scale-95 flex-shrink-0"
            aria-label="Subscribe"
          >
            <FontAwesomeIcon
              icon={faPaperPlane}
              className="w-4 h-4 text-white group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform duration-500 ease-out"
            />
          </button>
        </div>

        {/* Error Message */}
        {error && (
          <p className="text-orange-600 text-[10px] font-black uppercase tracking-tighter mt-3 ml-2 italic animate-pulse">
            {error}
          </p>
        )}
      </form>
    </div>
  );
};

export default FooterNewsletter;
